import {h, Fragment} from "preact"
import { useFacet } from '@nosto/preact'
import { useRef, useEffect, useState, useMemo } from 'preact/hooks'
import Checkbox from './elements/Checkbox'
import Icon from './elements/Icon'
import { customSortSizes } from './Product'

const caseInsensitiveSort = (a, b) => {
    return a.value.toLowerCase().localeCompare(b.value.toLowerCase())
}

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    const facetRef = useRef(null)
    const [wasFacetClicked, setWasFacetClicked] = useState(false);

    useEffect(() => {
        function handleClickOutside(event) {
            if (event.target.getAttribute('for') === 'toggle-mobile-sidebar') {
                return
            }

            if (facetRef.current && !facetRef.current.contains(event.target)) {
                if (active) toggleActive()
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [active, toggleActive])

    const toggleActiveUpdated = () => {
        const activeFacets = document.querySelectorAll('.ns-sidebar-dropdown.ns-active')
        activeFacets.forEach((facetElement) => {
            if (facetElement !== facetRef.current) {
                facetElement.classList.remove('ns-active')
            }
        })
        if (!wasFacetClicked && active) {
            setWasFacetClicked(true);    
        } else {
            toggleActive();
            setWasFacetClicked(true);
        }
        
    }

    const sortedData =
        facet.name === 'Størrelse' ? facet.data.sort(customSortSizes) : facet.data.sort(caseInsensitiveSort)

    const [searchTerm, setSearchTerm] = useState('');

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredData = useMemo(() => {
        if (!searchTerm) {
            return sortedData;
        }
        const lowerCaseSearchTerm = searchTerm.toLowerCase();
        return sortedData.filter(value =>
            value.value.toLowerCase().includes(lowerCaseSearchTerm)
        );
    }, [sortedData, searchTerm]);

    return (
        <li ref={facetRef} class={`ns-sidebar-dropdown ${active && wasFacetClicked ? 'ns-active' : ''}`}>
            <a
                class="ns-sidebar-facet-title ns-d-inline-block ns-relative ns-border-box ns-text-undecorated"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={toggleActiveUpdated}>
                {facet.name}
            </a>
            {active && wasFacetClicked && (
                <div class="ns-sidebar-submenu ns-d-none">
                    {sortedData?.length >= 8 && (<div>
                        <input
                            type="text"
                            placeholder={`Søk ${facet?.name || 'options'}`}
                            value={searchTerm}
                            onChange={handleSearchChange}
                            onKeyUp={handleSearchChange}
                            className="ns-facet-search-input"
                        />
                    </div>)}
                    <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                        {filteredData.map((value) => (
                            <li
                                class="ns-d-flex ns-align-items-center"
                                data-nosto-element="facet-setting"
                                onClick={(e) => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}>
                                <Checkbox value={value.value} selected={value.selected} />
                                <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1">
                                    ({value.count})
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </li>
    )
}
